<div
  [ngClass]="openMenuModal ? 'z-index-high' : ''"
  class="fleet-finder-header"
  id="div_fleet-finder-header_b6fe83ae"
>
  <div class="header-wrapper" id="div_header-wrapper_67a8bdea">
    <div
      class="fleet-finder-header-links"
      id="div_fleet-finder-header-links_7e38ed89"
    >
      <div class="logo-container" id="div_logo-container_cc9295cb">
        <a
          aria-label="TRM logo"
          title="TRM logo"
          routerLink="/launch"
          class="trinity-logo"
          id="a_trinity-logo_94e0832b"
        >
          <img
            width="165"
            height="35"
            src="../../../assets/logos/rsi_blk_bg.png"
            alt="TRINITY RAIL"
            aria-label="TRM logo"
            title="TRM logo"
            id="img_88bd0824"
          />
        </a>
      </div>

      <div
        [ngClass]="{ 'active-link': isActive(link.routerLink) }"
        [class.last]="last"
        class="header-link-container"
        *ngFor="let link of menuItems; let last = last"
        id="div_header-link-container_be073e3e"
      >
        <div class="header-link" id="div_header-link_f6915fbc">
          <a
            aria-label="TRM link"
            title="TRM link"
            class="link-1"
            (click)="setMixpanelTrack('search')"
            *ngIf="link.routerLink"
            [routerLink]="link.routerLink"
            id="a_link-1_5a6ecd1b"
            >{{ link.label }}</a
          >
          <a
            aria-label="TRM link"
            title="TRM link"
            class="link-2"
            (click)="setMixpanelTrack('fleet')"
            *ngIf="link.url"
            [href]="link.url"
            id="a_link-2_e26f1d95"
            >{{ link.label }}</a
          >
        </div>
      </div>
    </div>

    <div
      [ngClass]="user === null ? 'max-width-13' : 'fleet-finder-header-links-1'"
      id="div_e972767a"
    >
      <div
        class="header-link-container last"
        id="div_header-link-container_ead41e5d"
      >
        <div
          class="header-link sign-in"
          *ngIf="user === null"
          id="div_header-link_08345d99"
        >
          <a
            aria-label="SIGN IN"
            href="javascript:void(0)"
            title="SIGN IN"
            (click)="showLoginModal()"
            id="a_ac6da55a"
            >SIGN IN</a
          >
        </div>

        <div
          fxLayout="row"
          class="header-link"
          *ngIf="user !== null"
          id="div_header-link_14faa1d8"
        >
          <img
            style="margin-right: 8px"
            src="../../../assets/icons/person.svg"
            alt="TRINITY RAIL person"
            aria-label="TRINITY RAIL person"
            title="TRINITY RAIL person"
            id="img_abbb2c75"
          />
          <a
            aria-label="TRM link"
            title="TRM link"
            class="user-name"
            (click)="menu.toggle($event)"
            id="a_user-name_a891939e"
            >{{ user?.['contact-info']?.name?.split(' ')[0] }}</a
          >
          <img
            (click)="openMenuModalham()"
            alt="Toggle Menu"
            [attr.aria-label]="!openMenuModal ? 'Open Menu' : 'Close Menu'"
            title="Click to Toggle Menu"
            class="hamburger"
            [src]="
              !openMenuModal
                ? '/assets/icons/menu.svg'
                : '/assets/icons/close.svg'
            "
            id="img_hamburger_5abfe885"
          />
        </div>
        <p-menu
          #menu=""
          [popup]="true"
          [model]="loginMenuItems"
          id="p-menu_04461eb6"
        ></p-menu>
      </div>
    </div>
  </div>
</div>

<p-dialog
  position="top"
  id="openMenu"
  [(visible)]="openMenuModal"
  [closable]="false"
  [modal]="true"
  [style]="{ width: '100%', height: '100%' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="container p-2 h-100" id="div_container_9bb285b0">
    <div class="d-flex flex-column" id="div_d-flex_e326c6aa">
      <div
        class="d-flex flex-column align-items-center"
        id="div_d-flex_e7433d9e"
      >
        <div
          (click)="goToSearchInventory()"
          class="py-2"
          id="div_py-2_166effe3"
        >
          <h6 class="text-menu" id="h6_text-menu_3c38352a">Railcar Search</h6>
        </div>
        <div class="py-2" id="div_py-2_b1184f87">
          <h6 class="text-menu-black" id="h6_text-menu-black_c4446e12">
            fleet finder
          </h6>
        </div>
      </div>
      <div class="border-1 my-4" id="div_border-1_b6f896de"></div>
      <div
        class="d-flex flex-column align-items-center"
        id="div_d-flex_27801e20"
      >
        <div
          *ngFor="let item of loginMenuItems[0].items"
          class="py-2 mb-2"
          [id]="'div_' + item.id"
        >
          <h6
            *ngIf="
              item.id !== 'feedback' && currentRoute.url !== item.routerLink
            "
            class="text-menu-black"
            [id]="'h6_' + item.id"
            (click)="item.command ? item.command() : null"
          >
            {{ item.label }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
